export default {
  title: 'Mesas',
  count_one: '{{count}} mesa',
  count_other: '{{count}} mesas',
  filtered_count: '{{shown}} de {{count}} mesas',
  intro:
    'Cada mesa tiene su propio enlace y código QR. Los clientes que lo escanean piden para esa mesa, y ves la mesa en cada pedido.',
  migrated: {
    title: 'El servicio en habitación/mesa ahora es Pedidos en mesa',
    description:
      'Hemos añadido una mesa por cada uno de tus locales, con su nombre, para que los clientes puedan seguir pidiendo. Cámbiales el nombre para que coincidan con tus mesas o añade más.',
  },
  add: {
    label: 'Añadir una mesa',
    placeholder: 'p. ej. 7, 1A o Terraza 2',
    button: 'Añadir mesa',
  },
  errors: {
    empty: 'Introduce un nombre de mesa.',
    duplicate: 'Ya hay una mesa llamada «{{name}}».',
    too_long: 'El nombre de una mesa puede tener hasta {{max}} caracteres.',
  },
  columns: {
    order: 'Orden',
    table: 'Mesa y enlace',
    on: 'Activada',
    copy: 'Copiar enlace',
    qr: 'Código QR',
    actions: 'Acciones',
  },
  switch: {
    on: 'Activada',
    off: 'Desactivada',
  },
  buttons: {
    copy: 'Copiar enlace',
    copied: 'Copiado',
    download_qr: 'Descargar código QR',
    qr_short: 'Código QR',
    rename: 'Renombrar',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  aria: {
    move: 'Mover {{name}} (teclas de flecha)',
    switch: '{{name}} activada',
    copy: 'Copiar enlace de {{name}}',
    copied: 'Enlace copiado',
    download_qr: 'Descargar código QR de {{name}}',
    rename: 'Renombrar {{name}}',
    delete: 'Eliminar {{name}}',
    more: 'Más opciones para {{name}}',
    new_name: 'Nuevo nombre para {{name}}',
  },
  tooltips: {
    move: 'Arrastra para reordenar',
    move_disabled: 'Borra la búsqueda para reordenar',
  },
  rename_hint: 'El enlace y el código QR no cambian.',
  no_link: 'Aún no hay dirección de tienda',
  search: {
    placeholder: 'Buscar mesas',
    no_results: 'No hay ninguna mesa llamada «{{text}}».',
  },
  load_failed: {
    title: 'No se pudieron cargar las mesas.',
    retry: 'Reintentar',
  },
  empty: {
    title: 'Aún no hay mesas',
    text: 'Añade tus mesas arriba para obtener un enlace y un código QR para cada una. Los clientes no pueden pedir en una mesa hasta que añadas una.',
  },
  delete: {
    title: '¿Eliminar la mesa «{{name}}»?',
    warning:
      'Los códigos QR impresos de esta mesa dejarán de funcionar. A los clientes que escaneen uno se les pedirá que consulten al personal.',
    softer: 'Para detener los pedidos en esta mesa durante un tiempo, desactívala en su lugar.',
    confirm: 'Eliminar mesa',
    cancel: 'Cancelar',
  },
  announcements: {
    moved: '«{{name}}» movida a la posición {{position}} de {{count}}.',
    instructions: 'Para mover una mesa, enfoca su control y pulsa la flecha arriba o abajo.',
  },
  qr_image: {
    table: 'Mesa',
  },
  toasts: {
    added: 'Mesa «{{name}}» añadida',
    renamed: '«{{old}}» renombrada a «{{name}}»',
    deleted: 'Mesa «{{name}}» eliminada',
    switched_on: '«{{name}}» activada',
    switched_off: '«{{name}}» desactivada',
    failed_to_save: 'No se guardó. Inténtalo de nuevo.',
    failed_to_reorder: 'El nuevo orden no se guardó. Inténtalo de nuevo.',
    failed_to_download_qr: 'No se pudo guardar el código QR. Inténtalo de nuevo.',
    copy_failed: 'No se pudo copiar el enlace. Inténtalo de nuevo.',
  },
};
